import styled from "styled-components";

export const DataFlowBox = styled.div`
  display: flex;
  padding: 40px 28px;
  background: ${(props) => props.theme.colors.primary5};
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  gap: 18px;
`;

export const FlowLabelBox = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

export const FlowLabel = styled.div`
  height: 30px;
  color: ${(props) => props.theme.colors.flowLabelBox};
  font-size: 1.2rem;
  line-height: 30px;
  text-align: center;
`;

export const FlowList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
`;
